module.exports = __webpack_public_path__ + "img/menu-16.21867f00.jpg";